import { createTranslate } from "@digipost/translate";

import TRANSLATIONS from "../../../assets/strings/strings.json";
import { AVAILABLE_LANGUAGES } from "../../virksomhet/LoginMethod";
import { logError } from "../serverlog";

export const translator = createTranslate(
  [...AVAILABLE_LANGUAGES],
  TRANSLATIONS,
  logError,
);

export type TranslateTextKeyType = Parameters<typeof translator.translate>[1];
export type TranslateParamsType = Parameters<typeof translator.translate>[2];

type TranslateProvidedLanguagesType = Parameters<
  typeof translator.translate
>[3];

export type TranslateFunction = (
  textKey: TranslateTextKeyType,
  params?: TranslateParamsType,
  providedLanguages?: TranslateProvidedLanguagesType,
  language?: string,
) => string;
